import styled from "styled-components";

export const DocumentsInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0.5rem 0;
`;

export const DocumentDownloadLink = styled.a`
    color: rgba(172, 52, 33, 1);
    font-size: 0.9rem;
    margin: 0.5rem 0;
`;

export const DocumentFileInput = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

export const DocumentFileDisplay = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: auto;
    border-radius: 999em;
    background: rgba(172, 52, 33, 0.8);
    padding: 0.2rem;
    color: white;
`;

export const DocumentFileName = styled.div`
    flex: 1;
    padding: 0.5rem;
`;

export const DocumentFileLabel = styled.label`
    padding: 0.5rem;
    background: rgba(172, 52, 33, 1);
    border-radius: 999em;
    cursor: pointer;
    fonweight: 600;t-
`;